import { render, staticRenderFns } from "./ContentHomeWorkV2.vue?vue&type=template&id=8198dc5c&scoped=true"
import script from "./ContentHomeWorkV2.vue?vue&type=script&lang=js"
export * from "./ContentHomeWorkV2.vue?vue&type=script&lang=js"
import style0 from "./ContentHomeWorkV2.vue?vue&type=style&index=0&id=8198dc5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8198dc5c",
  null
  
)

export default component.exports